import { useRef, useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Button,
  Box,
  Divider,
  MenuItem,
  Typography,
  IconButton,
} from "@mui/material";
import MenuPopover from "./MenuPopover";
import Iconify from "./Iconify";
// import image from "../../Assets/Dashboard/Sidebar/image.png";
import { useSelector } from "react-redux";
import { colors } from "../../Styles/GlobalStyles/Variables";

const MENU_OPTIONS = [
  {
    label: "Home",
    icon: "eva:home-fill",
    linkTo: "#",
  },
  {
    label: "Profile",
    icon: "eva:person-fill",
    linkTo: "#",
  },
  {
    label: "Settings",
    icon: "eva:settings-2-fill",
    linkTo: "#",
  },
];

export default function AccountPopover() {
  const getUserDetails = (state) => state.usersReducer;
  const image = "";
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [images, setImages] = useState([]);
  const { authUser } = useSelector(getUserDetails);
  const [arrowOpen, setArrowOpen] = useState(false);
  let displayedUserDetails = {
    firstName: authUser.firstName ?? "",
    lastName: authUser.lastName ?? "",
    emailAddress: authUser.email ?? "",
  };

  if (authUser.role === "CORP_MEMBER") {
    const parsedName = authUser?.data?.cmName?.split(" ") ?? [];
    displayedUserDetails = {
      firstName: parsedName[0],
      lastName: parsedName[parsedName.length - 1],
      emailAddress: authUser?.data?.emailAddress,
    };
  }

  // if (authUser)
  // useEffect(() => {
  //   setImages(image);
  // }, [images]);

  const handleOpen = () => {
    setArrowOpen(true);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setArrowOpen(false);
  };

  const handleLogout = async (e) => {
    localStorage.removeItem("user");
    localStorage.removeItem("expirationTime");
    window.location.replace("/login");
  };

  return (
    <>
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: 10,
          // backgroundImage: `url(${images ? images : ""})`,
          backgroundColor: colors.primaryGreen,
          backgroundPosition: "center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          fontFamily: "Public Sans, sans-serif",
          fontWeight: 600,
          lineHeight: "44px",
          textAlign: "center",
        }}
      >
        <span style={{ color: "#fff" }}>
          {" "}
          {displayedUserDetails?.firstName?.charAt(0)}
          {displayedUserDetails?.lastName?.charAt(0)}
        </span>
      </div>
      <span
        style={{
          color: "#151D48",
          fontWeight: 600,
          fontFamily: "Public Sans, sans-serif",
        }}
      >
        {displayedUserDetails?.lastName} <br />
        <span style={{ color: "#737791", fontWeight: 400, fontSize: "14px" }}>
          {authUser.role === "SAED_State" && authUser?.state + " State"}
          {authUser.role === "SAED_LGI" && authUser?.lga}
          {authUser.role === "CORP_MEMBER" && authUser?.data?.deployedState}
        </span>
      </span>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
        }}
      >
        <Iconify
          icon={!arrowOpen ? "bx:chevron-down" : "bx:chevron-up"}
          sx={{ width: 16, height: 16, color: "#151D48" }}
        />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography
            variant="title1"
            noWrap
            style={{ fontWeight: 600, fontFamily: "Public Sans, sans-serif" }}
          >
            {displayedUserDetails?.firstName}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {displayedUserDetails?.emailAddress}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: "body2", py: 1, px: 2.5 }}
          >
            <Iconify
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24,
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            onClick={handleLogout}
            style={{
              border: "1px solid rgba(145, 158, 171, 0.32)",
              textTransform: "capitalize",
              backgroundColor: "transparent",
              color: "inherit",
              fontWeight: 600,
            }}
            fullWidth
            color="inherit"
            variant="outlined"
          >
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
